function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.0013 0.666504C3.95121 0.666504 0.667969 3.94975 0.667969 7.99984C0.667969 12.0499 3.95121 15.3332 8.0013 15.3332C12.0514 15.3332 15.3346 12.0499 15.3346 7.99984C15.3346 3.94975 12.0514 0.666504 8.0013 0.666504ZM10.4727 6.47124C10.7331 6.21089 10.7331 5.78878 10.4727 5.52843C10.2124 5.26808 9.79025 5.26808 9.5299 5.52843L8.0013 7.05703L6.47271 5.52843C6.21236 5.26808 5.79025 5.26808 5.5299 5.52843C5.26955 5.78878 5.26955 6.21089 5.5299 6.47124L7.05849 7.99984L5.5299 9.52843C5.26955 9.78878 5.26955 10.2109 5.5299 10.4712C5.79025 10.7316 6.21236 10.7316 6.47271 10.4712L8.0013 8.94265L9.5299 10.4712C9.79025 10.7316 10.2124 10.7316 10.4727 10.4712C10.7331 10.2109 10.7331 9.78878 10.4727 9.52843L8.94411 7.99984L10.4727 6.47124Z"
});

function SvgCrossCircleFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircleFilled);
export default __webpack_public_path__ + "static/media/cross-circle-filled.4aa4a950.svg";
export { ForwardRef as ReactComponent };